<div class="modal-header" [class.modal-header-mobile-school]="isMobile">
  <h4
    class="modal-title text-center w-100"
    id="modal-basic-title"
    [class.h6]="isMobile"
  >
    Selecione uma Escola/Perfil de acesso!
  </h4>
</div>
<div
  class="modal-body"
  [class.modal-body-mobile-school]="isMobile"
  [class.d-flex]="isMobile"
  [class.flex-column]="isMobile"
  [class.flex-grow-1]="isMobile"
  [class.min-h-0]="isMobile"
>
  <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
  <div
    (keydown)="handleKeyDown($event)"
    style="outline: none"
    [class.d-flex]="isMobile"
    [class.flex-column]="isMobile"
    [class.flex-grow-1]="isMobile"
    [class.min-h-0]="isMobile"
  >
    <div
      class="grid-container"
      [class.grid-container-mobile]="isMobile"
      [class.d-flex]="isMobile"
      [class.flex-column]="isMobile"
      [class.flex-grow-1]="isMobile"
      [class.min-h-0]="isMobile"
    >
      <form>
        <div
          class="mb-3 d-flex flex-column align-items-center row"
          [class.mb-2]="isMobile"
        >
          <div class="col-12 d-flex">
            <input
              #tableFilterInput
              autocomplete="off"
              id="table-filtering-search"
              [placeholder]="
                isMobile
                  ? 'Pesquisar por nome ou INEP'
                  : 'Pesquisar Escola (INEP ou Nome)'
              "
              class="form-control search-table"
              type="text"
              [formControl]="filter"
              tabindex="0"
            />
          </div>
        </div>
      </form>

      @if (!isMobile) {
        <div class="table-responsive">
          <table class="table select-school-table table-hover table-striped">
            <thead class="bg-ergon border-radius-thead">
              <tr>
                <td>Escola</td>
                <td>INEP Escola</td>
                <td>CPF</td>
              </tr>
            </thead>
            @for (group of filteredSchools; track group.GRUPO) {
              <tbody>
                <tr class="group">
                  <td colspan="3">{{ group.GRUPO }}</td>
                </tr>
                @for (
                  escola of group.ESCOLAS;
                  track escola.CPF + '-' + escola.CDESCOLA + '-' + escola.PERFILACESSO
                ) {
                  <tr
                    role="button"
                    tabindex="0"
                    (click)="clickTableSchool(escola)"
                    (keyup.Enter)="clickTableSchool(escola); confirm()"
                    [class.selected]="selectedSchool?.VALUE === escola.VALUE"
                    class="tr-hover text-nowrap select-school-row"
                  >
                    <td>{{ escola.ESCOLA }}</td>
                    <td>{{ escola.CDESCOLA }}</td>
                    <td>{{ escola.CPF }}</td>
                  </tr>
                }
              </tbody>
            }
          </table>
        </div>
      }

      @if (isMobile) {
        <div
          class="select-school-mobile-scroll flex-grow-1 overflow-auto"
          role="list"
        >
          @for (group of filteredSchools; track group.GRUPO) {
            <div class="school-mobile-group" role="presentation">
              <div class="school-mobile-group-title">{{ group.GRUPO }}</div>
              @for (
                escola of group.ESCOLAS;
                track escola.CPF + '-' + escola.CDESCOLA + '-' + escola.PERFILACESSO
              ) {
                <button
                  type="button"
                  class="select-school-row school-mobile-card btn w-100 text-start"
                  role="listitem"
                  (click)="clickTableSchool(escola)"
                  [class.selected]="selectedSchool?.VALUE === escola.VALUE"
                >
                  <span class="school-mobile-card-name">{{ escola.ESCOLA }}</span>
                  <span class="school-mobile-card-meta">
                    INEP {{ escola.CDESCOLA }} · CPF {{ escola.CPF }}
                  </span>
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer" [class.modal-footer-mobile-school]="isMobile">
  <div class="d-flex w-100 justify-content-center">
    <button
      type="button"
      class="btn btn-ergon"
      [class.w-100]="isMobile"
      [class.w-25]="!isMobile"
      (click)="confirm()"
    >
      OK
    </button>
  </div>
</div>
